import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadLaboratoryFinanceByLaboratoryId: ILaboratoryFinanceLoadByLaboratoryIdActionCreator = (laboratoryId) => {
        return {
            type: ACTION_LABORATORYFINANCE_LOAD_BY_LABORATORY_ID,
            laboratoryId
        }
    },
    LoadLaboratoryFinanceById: ILaboratoryFinanceLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_LABORATORYFINANCE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: ILaboratoryFinanceLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: ILaboratoryFinanceLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveLaboratoryFinance: ILaboratoryFinanceSaveActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYFINANCE_SAVE,
            formData
        }
    },
    SaveSuccess: ILaboratoryFinanceSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: ILaboratoryFinanceSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_SAVE_FAILURE,
            responseStatus
        }
    },

    ValidateLaboratoryFinance: ILaboratoryFinanceValidateActionCreator = (formData) => {
        return {
            type: ACTION_LABORATORYFINANCE_VALIDATE,
            formData
        }
    },
    ValidateSuccess: ILaboratoryFinanceValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: ILaboratoryFinanceValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    CreateLaboratoryFinance: ILaboratoryFinanceCreateActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYFINANCE_CREATE,
            laboratoryId
        }
    },
    CreateSuccess: ILaboratoryFinanceCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_LABORATORYFINANCE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: ILaboratoryFinanceCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_CREATE_FAILURE,
            responseStatus
        }
    },

    SyncLaboratoryFinance: ILaboratoryFinanceSyncActionCreator = (laboratoryId) => {

        return {
            type: ACTION_LABORATORYFINANCE_SYNC,
            laboratoryId
        }
    },
    SyncSuccess: ILaboratoryFinanceSyncSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_SYNC_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    SyncFailure: ILaboratoryFinanceSyncFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_LABORATORYFINANCE_SYNC_FAILURE,
            responseStatus
        }
    },

    Clear: ILaboratoryFinanceClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_LABORATORYFINANCE_CLEAR,
            propertiesToClear
        }
    },

    Filter: ILaboratoryFinanceFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_LABORATORYFINANCE_FILTER,
            formFilter
        }
    };



export const
    ACTION_LABORATORYFINANCE_LOAD_BY_LABORATORY_ID = "ACTION_LABORATORYFINANCE_LOAD_BY_LABORATORY_ID",
    ACTION_LABORATORYFINANCE_LOAD_BY_ID = "ACTION_LABORATORYFINANCE_LOAD_BY_ID",
    ACTION_LABORATORYFINANCE_LOAD_SUCCESS = "ACTION_LABORATORYFINANCE_LOAD_SUCCESS",
    ACTION_LABORATORYFINANCE_LOAD_FAILURE = "ACTION_LABORATORYFINANCE_LOAD_FAILURE",

    ACTION_LABORATORYFINANCE_SAVE = "ACTION_LABORATORYFINANCE_SAVE",
    ACTION_LABORATORYFINANCE_SAVE_SUCCESS = "ACTION_LABORATORYFINANCE_SAVE_SUCCESS",
    ACTION_LABORATORYFINANCE_SAVE_FAILURE = "ACTION_LABORATORYFINANCE_SAVE_FAILURE",

    ACTION_LABORATORYFINANCE_VALIDATE = "ACTION_LABORATORYFINANCE_VALIDATE",
    ACTION_LABORATORYFINANCE_VALIDATE_SUCCESS = "ACTION_LABORATORYFINANCE_VALIDATE_SUCCESS",
    ACTION_LABORATORYFINANCE_VALIDATE_FAILURE = "ACTION_LABORATORYFINANCE_VALIDATE_FAILURE",

    ACTION_LABORATORYFINANCE_CREATE = "ACTION_LABORATORYFINANCE_CREATE",
    ACTION_LABORATORYFINANCE_CREATE_SUCCESS = "ACTION_LABORATORYFINANCE_CREATE_SUCCESS",
    ACTION_LABORATORYFINANCE_CREATE_FAILURE = "ACTION_LABORATORYFINANCE_CREATE_FAILURE",

    ACTION_LABORATORYFINANCE_SYNC = "ACTION_LABORATORYFINANCE_SYNC",
    ACTION_LABORATORYFINANCE_SYNC_SUCCESS = "ACTION_LABORATORYFINANCE_SYNC_SUCCESS",
    ACTION_LABORATORYFINANCE_SYNC_FAILURE = "ACTION_LABORATORYFINANCE_SYNC_FAILURE",

    ACTION_LABORATORYFINANCE_CLEAR = "ACTION_LABORATORYFINANCE_CLEAR",

    ACTION_LABORATORYFINANCE_FILTER = "ACTION_LABORATORYFINANCE_FILTER";

export interface ILaboratoryFinanceLoadByLaboratoryIdAction {
    type: "ACTION_LABORATORYFINANCE_LOAD_BY_LABORATORY_ID";
    laboratoryId: number;
}

export interface ILaboratoryFinanceLoadByLaboratoryIdActionCreator {
    (laboratoryId: number): ILaboratoryFinanceLoadByLaboratoryIdAction;
}

export interface ILaboratoryFinanceLoadSuccessAction {
    type: "ACTION_LABORATORYFINANCE_LOAD_SUCCESS";
    formData: Dtos.LaboratoryFinance | Dtos.LaboratoryFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryFinanceLoadSuccessActionCreator {
    (
        formData: Dtos.LaboratoryFinance | Dtos.LaboratoryFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryFinanceLoadSuccessAction;
}

export interface ILaboratoryFinanceLoadFailureAction {
    type: "ACTION_LABORATORYFINANCE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryFinanceLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryFinanceLoadFailureAction;
}

export interface ILaboratoryFinanceLoadByIdAction {
    type: "ACTION_LABORATORYFINANCE_LOAD_BY_ID";
    id: number;
}

export interface ILaboratoryFinanceLoadByIdActionCreator {
    (id: number): ILaboratoryFinanceLoadByIdAction;
}

export interface ILaboratoryFinanceSaveAction {
    type: "ACTION_LABORATORYFINANCE_SAVE";
    formData: Dtos.LaboratoryFinance;

}

export interface ILaboratoryFinanceSaveActionCreator {
    (
        formData: Dtos.LaboratoryFinance
    ): ILaboratoryFinanceSaveAction;
}

export interface ILaboratoryFinanceSaveSuccessAction {
    type: "ACTION_LABORATORYFINANCE_SAVE_SUCCESS";
    formData: Dtos.LaboratoryFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryFinanceSaveSuccessActionCreator {
    (
        formData: Dtos.LaboratoryFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryFinanceSaveSuccessAction;
}

export interface ILaboratoryFinanceSaveFailureAction {
    type: "ACTION_LABORATORYFINANCE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryFinanceSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryFinanceSaveFailureAction;
}

export interface ILaboratoryFinanceValidateAction {
    type: "ACTION_LABORATORYFINANCE_VALIDATE";
    formData: Dtos.LaboratoryFinance;

}

export interface ILaboratoryFinanceValidateActionCreator {
    (
        formData: Dtos.LaboratoryFinance
    ): ILaboratoryFinanceValidateAction;
}

export interface ILaboratoryFinanceValidateSuccessAction {
    type: "ACTION_LABORATORYFINANCE_VALIDATE_SUCCESS";
    formData: Dtos.LaboratoryFinance;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface ILaboratoryFinanceValidateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryFinance,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryFinanceValidateSuccessAction;
}

export interface ILaboratoryFinanceValidateFailureAction {
    type: "ACTION_LABORATORYFINANCE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryFinanceValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryFinanceValidateFailureAction;
}

export interface ILaboratoryFinanceCreateAction {
    type: "ACTION_LABORATORYFINANCE_CREATE",
    laboratoryId: number
}

export interface ILaboratoryFinanceCreateActionCreator {
    (laboratoryId: number): ILaboratoryFinanceCreateAction
}

export interface ILaboratoryFinanceCreateSuccessAction {
    type: "ACTION_LABORATORYFINANCE_CREATE_SUCCESS";
    formData: Dtos.LaboratoryFinance;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
}

export interface ILaboratoryFinanceCreateSuccessActionCreator {
    (
        formData: Dtos.LaboratoryFinance,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): ILaboratoryFinanceCreateSuccessAction;
}

export interface ILaboratoryFinanceCreateFailureAction {
    type: "ACTION_LABORATORYFINANCE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryFinanceCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryFinanceCreateFailureAction;
}

export interface ILaboratoryFinanceClearAction {
    type: "ACTION_LABORATORYFINANCE_CLEAR";
    propertiesToClear?: string[];
}

export interface ILaboratoryFinanceClearActionCreator {
    (propertiesToClear?: string[]): ILaboratoryFinanceClearAction;
}

export interface ILaboratoryFinanceFilterActionCreator {
    (formFilter: IFormFilter): ILaboratoryFinanceFilterAction;
}

export interface ILaboratoryFinanceFilterAction {
    type: "ACTION_LABORATORYFINANCE_FILTER";
    formFilter: IFormFilter;
}

export interface ILaboratoryFinanceSyncAction {
    type: "ACTION_LABORATORYFINANCE_SYNC",
    laboratoryId: number
}

export interface ILaboratoryFinanceSyncActionCreator {
    (laboratoryId: number): ILaboratoryFinanceSyncAction
}

export interface ILaboratoryFinanceSyncSuccessAction {
    type: "ACTION_LABORATORYFINANCE_SYNC_SUCCESS";
    formData: Dtos.LaboratoryFinance[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryFinanceSyncSuccessActionCreator {
    (
        formData: Dtos.LaboratoryFinance[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): ILaboratoryFinanceSyncSuccessAction;
}

export interface ILaboratoryFinanceSyncFailureAction {
    type: "ACTION_LABORATORYFINANCE_SYNC_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface ILaboratoryFinanceSyncFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): ILaboratoryFinanceSyncFailureAction;
}

export type LaboratoryFinanceAction =
    ILaboratoryFinanceLoadByLaboratoryIdAction |
    ILaboratoryFinanceLoadByIdAction |
    ILaboratoryFinanceLoadFailureAction |
    ILaboratoryFinanceLoadSuccessAction |
    ILaboratoryFinanceSaveAction |
    ILaboratoryFinanceSaveSuccessAction |
    ILaboratoryFinanceSaveFailureAction |
    ILaboratoryFinanceValidateAction |
    ILaboratoryFinanceValidateSuccessAction |
    ILaboratoryFinanceValidateFailureAction |
    ILaboratoryFinanceCreateAction |
    ILaboratoryFinanceCreateSuccessAction |
    ILaboratoryFinanceCreateFailureAction |
    ILaboratoryFinanceSyncAction |
    ILaboratoryFinanceSyncSuccessAction |
    ILaboratoryFinanceSyncFailureAction |
    ILaboratoryFinanceClearAction | 
    ILaboratoryFinanceFilterAction;
